module.exports = __webpack_public_path__ + "fonts/glyphicons-halflings-regular.7ad17c60.eot";